var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBranding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7777 19.8489L17.3922 16.4633C18.9613 14.6535 19.7669 12.3054 19.6392 9.91347C19.5116 7.52155 18.4606 5.27252 16.7078 3.64004C14.9549 2.00756 12.6369 1.11905 10.2419 1.16162C7.84699 1.20419 5.56203 2.17453 3.86828 3.86828C2.17453 5.56203 1.20419 7.84699 1.16162 10.2419C1.11905 12.6369 2.00756 14.9549 3.64004 16.7078C5.27252 18.4606 7.52155 19.5116 9.91347 19.6392C12.3054 19.7669 14.6535 18.9613 16.4633 17.3922L19.8489 20.7777L20.7777 19.8489ZM2.53607 10.4377C2.53486 8.87468 2.99726 7.34637 3.86477 6.04614C4.73228 4.74592 5.96593 3.73219 7.40967 3.1332C8.8534 2.5342 10.4424 2.37685 11.9755 2.68105C13.5087 2.98524 14.9172 3.73732 16.0229 4.84215C17.1286 5.94697 17.8817 7.3549 18.1871 8.88784C18.4925 10.4208 18.3364 12.0099 17.7385 13.4541C17.1406 14.8982 16.1279 16.1327 14.8283 17.0012C13.5287 17.8697 12.0008 18.3333 10.4377 18.3333C8.34364 18.3317 6.33569 17.4995 4.85436 16.0193C3.37304 14.5391 2.53931 12.5318 2.53607 10.4377Z",
    fill: "#181A20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48999 8.46387H14.3917V9.77776H6.48999V8.46387Z",
    fill: "#181A20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48999 11.0978H10.4378V12.4117H6.48999V11.0978Z",
    fill: "#181A20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranding);
export default __webpack_public_path__ + "static/media/branding.263d1051da9395083c6f4b1d429ea6c5.svg";
export { ForwardRef as ReactComponent };